export default {
	buffering: "Buffering",
	connected: "Conectado!",
	connecting: "Conectando...",
	controls: "- Seu Controle -",
	copied: "Copiado!",
	crtEffect: "Efeito CRT",
	dragARomHere: "Arraste uma ROM de NES aqui!",
	enabled_false: "Desabilitado",
	enabled_true: "Habilitado",
	errors: {
		connectionFailed: "CONEXÃO FALHOU :(",
		invalidRom: "ROM inválida :(",
		serverIsDown: "O servidor multiplayer não está online :("
	},
	input: "Controle",
	link: "link",
	loading: "Carregando...",
	pressStart: "APERTE START",
	setDefaults: "Restaurar padrões",
	settings: "Configurações",
	shareThis: "Compartilhe o",
	sound: "Som",
	swap: "Troca de controle",
	swapButton: "RB",
	toPlayWithSomeone: "para jogar com alguém!",
	waiting: "Aguardando...",
	yourController: "Seu controle"
};
